"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["DetailPage"] = "DETAIL_PAGE";
    PageType["ThankYouPage"] = "THANK_YOU_PAGE";
})(PageType = exports.PageType || (exports.PageType = {}));
